/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import {useIsFocused} from '@react-navigation/native';
import {StyleSheet} from 'react-native';
import {getPaymentHistory} from '../../apis';
import {px, useAsync, useIsLandscape} from '../../utils';
import {AppLoadingIndicator, Page} from '../components';
import NotFound from '../components/NotFound';
import PaymentDetail from './PaymentDetail';

const PaymentHistory = () => {
  const isFocused = useIsFocused();
  const isLandscape = useIsLandscape();
  const {loading, value: list} = useAsync(() => getPaymentHistory(), [
    isFocused,
  ]);

  return (
    <Page
      header={{title: 'Payment history', showDrawerAction: true}}
      scrollViewStyle={[
        styles.container,
        isLandscape ? {paddingHorizontal: 8, paddingTop: 8} : undefined,
      ]}>
      {loading ? (
        <AppLoadingIndicator />
      ) : list && list.length > 0 ? (
        list?.map((item, index) => <PaymentDetail data={item} key={index} />)
      ) : (
        <NotFound />
      )}
    </Page>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: px(50),
  },
});

export default PaymentHistory;
